import * as React from "react";
import { forwardRef } from "react";
const PowerButtonIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M20.25 12.735a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 1 0 16.5 0zm1.5 0a9.75 9.75 0 1 1-19.5 0 9.75 9.75 0 1 1 19.5 0zm-13.7 2.1a3.95 3.95 0 0 1 .747-2.328l.049-.06a.75.75 0 0 1 1.165.941 2.45 2.45 0 0 0-.461 1.447c0 1.341 1.08 2.422 2.402 2.422s2.403-1.08 2.403-2.422a2.42 2.42 0 0 0-.367-1.287l-.106-.155-.043-.064a.75.75 0 0 1 1.201-.886l.049.059.171.252a3.92 3.92 0 0 1 .595 2.081c0 2.162-1.744 3.922-3.903 3.922s-3.902-1.76-3.902-3.922zm3.153-.72v-3.607a.75.75 0 1 1 1.5 0v3.607a.75.75 0 1 1-1.5 0zm2.461-7.33.077.004a.75.75 0 0 1-.077 1.496h-3.423a.75.75 0 0 1 0-1.5h3.423z"
}));
const ForwardRef = forwardRef(PowerButtonIcon);
export default ForwardRef;